const ddados = {
  Titulo: 'Consultar Protocolo',
  Campos: {
    CpfCnpjSolicitante: {
      Tipo: 'mask',
      Mascara: 'CPFCNPJ',
      Label: 'CPF/CNPJ Solicitante',
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    CpfMei: {
      Tipo: 'mask',
      Mascara: 'CPF',
      Label: 'CPF do MEI',
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    CnpjEmpresa: {
      Tipo: 'mask',
      Mascara: 'CNPJ',
      Label: 'CNPJ Empresa',
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    Password: {
      Tipo: 'text',
      TipoInput: 'password',
      Label: 'Senha',
      BootstrapColuna: 4,
      Obrigatorio: true,
      Tamanho: 6,
    },
    Cep: {
      Tipo: 'text',
      Label: 'Cep',
      Placeholder: '',
      BootstrapColuna: 3,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Estado: {
      Tipo: 'text',
      Label: 'UF',
      Placeholder: '',
      BootstrapColuna: 3,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Cidade: {
      Tipo: 'text',
      Label: 'Cidade',
      Placeholder: '',
      BootstrapColuna: 6,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Bairro: {
      Tipo: 'text',
      Label: 'Bairro',
      Placeholder: '',
      BootstrapColuna: 3,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Tipo: {
      Tipo: 'text',
      Label: 'Tipo',
      Placeholder: '',
      BootstrapColuna: 3,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Logradouro: {
      Tipo: 'text',
      Label: 'Logradouro',
      Placeholder: '',
      BootstrapColuna: 6,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Numero: {
      Tipo: 'text',
      Label: 'Número',
      Placeholder: '',
      BootstrapColuna: 3,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Complemento: {
      Tipo: 'text',
      Label: 'Complemento',
      Placeholder: '',
      BootstrapColuna: 9,
      Obrigatorio: false,
      Desabilitado: true,
    },
    Email: {
      Tipo: 'text',
      TipoInput: 'email',
      Label: 'Email',
      Placeholder: 'Email',
      BootstrapColuna: 12,
      Tamanho: 150,
      Obrigatorio: true,
      Desabilitado: false,
    },
    MotivoBaixa: {
      Tipo: 'textarea',
      Label: 'Motivo',
      Placeholder: '',
      Tamanho: 8000,
      BootstrapColuna: 12,
      Obrigatorio: true,
      Desabilitado: false,
    },
    DataTerminoAtividade: {
      Tipo: 'date',
      Label: 'Data Término Atividade',
      BootstrapColuna: 3,
      Obrigatorio: true,
      Desabilitado: false,
    },
  },
};

export { ddados };
